import styled from 'styled-components';
import { getUrlWithToken } from '../../../../utils/common';

export const StyledCourseHero = styled.div.withConfig({
  shouldForwardProp: (prop) => !['cover'].includes(prop),
})`
  background-color: ${({ theme }) => theme.colors.themeColor};
  background-image: url(${({ cover }) => getUrlWithToken(cover)});
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: fit-content;
  position: relative;
  margin-bottom: 48px;
`;

export const Shadow = styled.div`
  height: fit-content;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(192, 192, 192, 0.38) -56.08%,
    rgba(0, 0, 0, 0.71) 100%
  );
`;

export const Overlay = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.white};
  width: 100%;
  min-height: 303px;
  padding-block: 32px;
`;

export const TitleBlock = styled.div`
  margin-bottom: 40px;

  .course-title {
    max-width: 90%;
  }

  /* badge */
  > div:first-child {
    margin-bottom: 24px;
  }
`;

export const Overtitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  margin-bottom: 16px;

  > span {
    &::after {
      content: ' - ';
    }

    &:last-child::after {
      display: none;
    }
  }
`;

export const BadgeCtaBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    row-gap: 40px;
  }
`;

export const BadgeContainer = styled.div`
  display: flex;
  align-items: center;

  > *:not(:last-child) {
    padding-right: 32px;
    border-right: 0.5px solid ${({ theme }) => theme.colors.white};
    margin-right: 32px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 32px;
  margin-left: 20px;

  button {
    color: ${({ theme }) => theme.colors.white} !important;

    &:hover {
      color: ${({ theme }) => theme.colors.silverGrey} !important;
    }
  }

  @media ${(props) => props.theme.device.laptop} {
    flex-flow: row;
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-end;

    div {
      width: 100%;
      text-align: right;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-flow: column-reverse;
    row-gap: 8px;
    width: 100%;
    margin-left: 0;

    div {
      text-align: center;
    }

    a {
      display: block;
      width: 100%;
    }
  }

  .btn-recommend {
    &.recommended svg {
      fill: ${(props) => props.theme.colors.link} !important;
    }
  }
`;
